<div class="wrap-header">
    <header>
        <div class="container">
            <nav class="navbar">
                <a class="navbar-brand" href="/">
                    <img alt="DeltaWizard.ai" height="24" src="assets/images/logo.svg">
                </a>
                <!-- <button class="btn btn-icon btn-transparent text-500"><span class="material-icons-outlined">keyboard_double_arrow_left</span></button> -->
                <!-- <button class="btn btn-icon btn-transparent text-500"><span class="material-icons-outlined">keyboard_double_arrow_right</span></button> -->
                <ul class="breadcrumb">
                    <li class="breadcrumb-item"><a routerLink="/projects">Projects</a><span class="divider">/</span></li>
                    <li class="breadcrumb-item">
                        <span>Marketing</span>
                        <span class="divider">/</span>
                    </li>
                    <li class="breadcrumb-item">
                        <span [matMenuTriggerFor]="menuBreadcrumb" class="breadcrumb-item__dropdown">
                            <span>202408 Travel (Small)</span>
                            <span class="material-icons-outlined">keyboard_arrow_down</span>
                        </span>
                        <mat-menu #menuBreadcrumb="matMenu">
                            <button mat-menu-item>Back to Import Wizard</button>
                            <button mat-menu-item>Project setings</button>
                            <button mat-menu-item>Export DWP</button>
                            <button mat-menu-item>Export XLS</button>
                            <button mat-menu-item>Delete</button>
                        </mat-menu>
                    </li>
                </ul>

                <main-menu></main-menu>
            </nav>
        </div>
    </header>
    <header *ngIf="false"><!-- <skeleton, for later use  -->
        <div class="container">
            <nav class="navbar">
                <div class="skeleton skeleton-icon-button"></div>
                <div class="skeleton skeleton-breadcrumbs"></div>
                <div class="skeleton skeleton-icon-button"></div>
            </nav>
        </div>
    </header>
</div>
